import React, { useState, useEffect } from 'react'

import SwitchFromTo from './components/SwitchFromTo'
import TransferAtoU from './components/TransferAtoU'
import TransferUtoA from './components/TransferUtoA'

import useAgentData from '../../hooks/useAgentData';
import useUserData from '../../hooks/useUserData';
import useTransferTypeData from '../../hooks/useTransactionTypeData';

const Transfer = () => {

    // const [transferDate, setTransferDate] = useState(new Date().toISOString().split('T')[0]);
    const [isFrom, setIsFrom] = useState(true);
    const [expandTo, setExpandTo] = useState(false);

    const [transferFromData, setTransferFromData] = useAgentData([]);
    const [transferToData, setTransferToData] = useUserData([]);
    const [transferTypeData, setTransferTypeData] = useTransferTypeData([]);
    
    return (
        <div>
            <div className='bg-white rounded-sm h-[90dvh] mx-2 my-2'>

                <div className='w-64 h-[23%] flex justify-end items-end mx-auto mb-10'>
                    {/* <input 
                        type="date" 
                        name='transferDate'
                        value={transferDate}
                        onChange={(e) => setTransferDate(e.target.value)} 
                        className='bg-bgColor px-2 py-2 outline-none w-[185px] rounded-sm mb-16 shadow-lg ' /> */}

                        <SwitchFromTo isFrom={isFrom} setIsFrom={setIsFrom} />

                </div>

                {isFrom ? 
                        <TransferAtoU 
                            transferFromData={transferFromData}
                            transferToData={transferToData} 
                            transferTypeData={transferTypeData}
                            expandTo={expandTo}
                            setExpandTo={setExpandTo}
                        /> 
                    :
                        <TransferUtoA 
                            transferFromData={transferFromData}
                            transferToData={transferToData} 
                            transferTypeData={transferTypeData}
                            expandTo={expandTo}
                            setExpandTo={setExpandTo}
                        />}

            </div>
        </div>
    )
}

export default Transfer